import React from 'react'
import './App.css'
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from 'react-router-dom'
import Display from './components/settings/Display'
import Panel from './components/Panel'
import QR from './components/QR'
import { AuthProvider, useAuth } from './AuthContext'
import GoogleAuth from './components/GoogleSignin'
import { Provider } from 'react-redux'
import apiConfigured from './slice/ApiSlice'
import GlobalErrorHandler from './components/GlobalErrorHandler'

const ProtectedRoute: React.FC<{ element: React.ReactElement }> = ({
  element,
}) => {
  const token = localStorage.getItem('adminToken')

  if (!token) {
    return <GoogleAuth />
  }

  return element
}

function AppRoutes() {
  const { isAuthenticated } = useAuth()

  return (
    <Routes>
      <Route path="/login" element={<GoogleAuth />} />
      <Route element={<ProtectedRoute element={<Panel />} />}>
        <Route path="/" element={<QR />} />
        <Route path="/qr" element={<QR />} />
        <Route path="/settings" element={<Display />} />
      </Route>
      <Route
        path="*"
        element={<Navigate to={isAuthenticated ? '/' : '/login'} replace />}
      />
    </Routes>
  )
}

function App() {
  return (
    <Provider store={apiConfigured}>
      <GlobalErrorHandler />
      <AuthProvider>
        <Router>
          <AppRoutes />
        </Router>
      </AuthProvider>
    </Provider>
  )
}

export default App
